<div class="d-flex justify-content-end w-100 s-mb-5">
  <z-button
    label="add"
    [label]="'new' | transloco"
    (click)="openNewItemDialog()"
    [icon]="'add'"
  >
  </z-button>
</div>
<app-simple-table
  *ngIf="formControlRef()?.value?.length"
  [columns]="columns()"
  [actions]="actions()"
  [items]="formControlRef()?.value"
  (action)="tableAction($event)"
>
</app-simple-table>
<app-empty-data
  *ngIf="!formControlRef()?.value || formControlRef()?.value?.length === 0"
>
</app-empty-data>
